import { defaultTheme } from '../const';

export const parseTheme = theme => {
  if (!theme) return defaultTheme;

  if (typeof theme === 'string') {
    try {
      return JSON.parse(theme);
    } catch (e) {
      console.error('Failed to parse theme string:', e);
      return defaultTheme;
    }
  }

  if (typeof theme === 'object') {
    return theme;
  }
};
